import { ClassNameMap } from "@material-ui/styles/withStyles";
import { DetailsCardProps, Typography } from "@welldigital/components";
import { USER_TARGETS } from "@welldigital/ui-common/Authentication/envDerivedConstants";
import { ProfileTarget, UserProfileLink } from "@welldigital/ui-common";
import { signUpTargets } from "../../envDerivedConstants";
import { goToURL } from "../../utils";

const getButtonAttrs = (availableLinksIds: Set<string>, id: ProfileTarget) => {
  return {
    ...(availableLinksIds.has(id)
      ? {
          children: "✓",
          disabled: true,
        }
      : {
          children: "Create account",
          onClick: goToURL.bind(null, signUpTargets[id]),
        }),
  };
};

type GetCardsDataResult = Record<
  ProfileTarget,
  { cardProps: DetailsCardProps; content: JSX.Element }
>;
export const getCardsData = (
  classes: ClassNameMap<"cardContentText">,
  availableLinks: UserProfileLink[]
): GetCardsDataResult => {
  const availableLinksIds = availableLinks.reduce((acc, entry) => {
    acc.add(entry.id);
    return acc;
  }, new Set<string>());

  return Object.values(USER_TARGETS).reduce((acc, entry) => {
    const id = entry.id as ProfileTarget;
    if (!(id in signUpTargets)) return acc;
    acc[id] = {
      cardProps: {
        title: entry.label,
        icons: [{ component: entry.icon, color: "primary" }],
        buttons: [
          {
            color: "primary",
            ...getButtonAttrs(availableLinksIds, id),
            title: signUpTargets[id],
          },
        ],
      },
      content: (
        <Typography className={classes.cardContentText}>
          {entry.signupDescription}
        </Typography>
      ),
    };
    return acc;
  }, {} as GetCardsDataResult);
};
